import {
  ROUTE_BOOK_ADD_ONS,
  ROUTE_BOOK_LOCATION,
  ROUTE_BOOK_SCHEDULE,
  ROUTE_BOOK_SERVICES,
} from '../util/constants';

/**
 * The consumer skin's steps. The address step shares today's URL
 * (/book/location); the others are its own. Confirmation and the prepay
 * page are shared with the fleet skin.
 */
export const CONSUMER_ADDRESS = ROUTE_BOOK_LOCATION;
export const CONSUMER_CAR = '/book/car';
export const CONSUMER_PLAN = '/book/plan';
export const CONSUMER_DAY = '/book/day';
export const CONSUMER_DETAILS = '/book/details';

export const CONSUMER_STEPS = [
  CONSUMER_ADDRESS,
  CONSUMER_CAR,
  CONSUMER_PLAN,
  CONSUMER_DAY,
  CONSUMER_DETAILS,
] as const;

/** What the booking already holds, for mapping a step across skins. */
export interface StepProgress {
  hasAddress: boolean;
  hasCar: boolean;
  hasServices: boolean;
  hasTime: boolean;
}

/**
 * The fleet page for where the visitor is on the consumer skin: the car
 * and plan steps are today's Services page, the day and details steps
 * today's Schedule page (which holds both).
 */
export function consumerToFleetPath(path: string, p: StepProgress): string {
  switch (path) {
    case CONSUMER_CAR:
    case CONSUMER_PLAN:
      return p.hasAddress ? ROUTE_BOOK_SERVICES : ROUTE_BOOK_LOCATION;
    case CONSUMER_DAY:
    case CONSUMER_DETAILS:
      if (!p.hasAddress) return ROUTE_BOOK_LOCATION;
      return p.hasServices ? ROUTE_BOOK_SCHEDULE : ROUTE_BOOK_SERVICES;
    default:
      return path;
  }
}

/** The consumer step for a fleet page: the first one not answered yet. */
export function fleetToConsumerPath(path: string, p: StepProgress): string {
  switch (path) {
    case ROUTE_BOOK_SERVICES:
    case ROUTE_BOOK_ADD_ONS:
      if (!p.hasAddress) return CONSUMER_ADDRESS;
      return p.hasCar ? CONSUMER_PLAN : CONSUMER_CAR;
    case ROUTE_BOOK_SCHEDULE:
      if (!p.hasAddress) return CONSUMER_ADDRESS;
      if (!p.hasCar) return CONSUMER_CAR;
      if (!p.hasServices) return CONSUMER_PLAN;
      return p.hasTime ? CONSUMER_DETAILS : CONSUMER_DAY;
    default:
      return path;
  }
}

/** The first consumer step still to answer (prefilled links land here). */
export function nextUnansweredStep(p: StepProgress): string {
  if (!p.hasAddress) return CONSUMER_ADDRESS;
  if (!p.hasCar) return CONSUMER_CAR;
  if (!p.hasServices) return CONSUMER_PLAN;
  if (!p.hasTime) return CONSUMER_DAY;
  return CONSUMER_DETAILS;
}
